import GenericRequest, { METHOD_PUT } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class WorkerCreateTask extends GenericRequest {

    _request; // WorkerCreateRequest

    constructor(request) {
        super(METHOD_PUT, ApiEndpoints.WORKER_ADD);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/create/worker-create/WorkerCreateTask.js